import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => useContext(ThemeContext);

const STORAGE_KEY = 'click_theme';

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => localStorage.getItem(STORAGE_KEY) || 'system');
  const [resolvedTheme, setResolvedTheme] = useState('dark');

  // Resuelve y aplica el tema real (light/dark) según la preferencia guardada.
  // Si theme === 'system', sigue window.matchMedia en tiempo real -- incluyendo
  // un chequeo en visibilitychange, porque algunos navegadores móviles pausan
  // el listener de matchMedia mientras la app está en segundo plano y solo
  // reflejan el cambio del sistema al volver a foreground.
  useEffect(() => {
    if (theme !== 'system') {
      setResolvedTheme(theme);
      return;
    }

    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => setResolvedTheme(mql.matches ? 'dark' : 'light');
    apply();

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') apply();
    };

    mql.addEventListener('change', apply);
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      mql.removeEventListener('change', apply);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', resolvedTheme);
  }, [resolvedTheme]);

  const setTheme = (nuevoTheme) => {
    setThemeState(nuevoTheme);
    localStorage.setItem(STORAGE_KEY, nuevoTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, resolvedTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
